import { apiService } from "./apiService";

const CONTENTS_URL = "/contents";

const material = {
  notice: process.env.REACT_APP_NOTICE_MODULE_IDX,
  material: process.env.REACT_APP_TBM_MODULE_IDX,
  banner: process.env.REACT_APP_BANNER_MODULE_IDX,
  guide: process.env.REACT_APP_GUIDE_MODULE_IDX,
}

export const getContents = async (params: ContentGetApiProps, moduleIdx: keyof typeof material): Promise<ContentGetApiResponse> => {
  try {
    params.module_idx = material[moduleIdx];
    const response = await apiService.get<ContentGetApiResponse>(`${CONTENTS_URL}`, params);
    return response;
  } catch (error) {
    throw error;
  }
};

export const postContents = async (data: ContentPostApiData, moduleIdx: keyof typeof material): Promise<ContentGetApiResponse> => {
  try {
    data.module_idx = material[moduleIdx];
    const response = await apiService.post<ContentGetApiResponse>(`${CONTENTS_URL}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const putContents = async (data: ContentPostApiData, moduleIdx: keyof typeof material): Promise<ContentGetApiResponse> => {
  try {
    data.module_idx = material[moduleIdx];
    const response = await apiService.put<ContentGetApiResponse>(`${CONTENTS_URL}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const delContents = async (params: ContentDelApiProps, moduleIdx: keyof typeof material): Promise<ContentDelApiResponse> => {
  try {
    params.module_idx = material[moduleIdx];
    const response = await apiService.delete<ContentDelApiResponse>(`${CONTENTS_URL}`, params);
    return response;
  } catch (error) {
    throw error;
  }
};

export const contentsList = async (params: ListGetApiProps, moduleIdx: keyof typeof material): Promise<ListGetApiResponse> => {
  try {
    params.module_idx = material[moduleIdx];
    const response = await apiService.get<ListGetApiResponse>(`${CONTENTS_URL}/list`, params);
    return response;
  } catch (error) {
    throw error;
  }
}